// Nepal Administrative Divisions Data (नेपालका प्रशासनिक विभाजन)
// ७ प्रदेश, ७७ जिल्ला, र प्रमुख नगरपालिकाहरू

export const NEPAL_LOCATIONS = {
  "कोशी प्रदेश": {
    districts: {
      "भोजपुर": ["भोजपुर नगरपालिका", "षडानन्द नगरपालिका", "हतुवागढी गाउँपालिका", "रामप्रसाद राई गाउँपालिका"],
      "धनकुटा": ["धनकुटा नगरपालिका", "पाख्रिबास नगरपालिका", "महालक्ष्मी नगरपालिका", "सँगुरीगढी गाउँपालिका"],
      "इलाम": ["इलाम नगरपालिका", "माई नगरपालिका", "देउमाई नगरपालिका", "सूर्योदय नगरपालिका"],
      "झापा": ["मेचीनगर नगरपालिका", "दमक नगरपालिका", "कनकाई नगरपालिका", "भद्रपुर नगरपालिका", "अर्जुनधारा नगरपालिका"],
      "खोटाङ": ["दिक्तेल रुपाकोट मझुवागढी नगरपालिका", "हलेसी तुवाचुङ नगरपालिका", "जन्तेढुंगा गाउँपालिका"],
      "मोरङ": ["विराटनगर महानगरपालिका", "उर्लाबारी नगरपालिका", "बेलबारी नगरपालिका", "लेटाङ नगरपालिका", "सुन्दरहरैचा नगरपालिका"],
      "ओखलढुंगा": ["सिद्धिचरण नगरपालिका", "चम्पादेवी गाउँपालिका", "सुनकोशी गाउँपालिका"],
      "पाँचथर": ["फिदिम नगरपालिका", "हिलिहाङ गाउँपालिका", "याङवरक गाउँपालिका"],
      "सङ्खुवासभा": ["चैनपुर नगरपालिका", "धर्मदेवी नगरपालिका", "खाँदबारी नगरपालिका"],
      "सोलुखुम्बु": ["सोलुदुधकुण्ड नगरपालिका", "महाकुलुङ गाउँपालिका", "लिखु पिके गाउँपालिका"],
      "सुनसरी": ["धरान उपमहानगरपालिका", "इटहरी उपमहानगरपालिका", "इनरुवा नगरपालिका", "दुहवी नगरपालिका"],
      "ताप्लेजुङ": ["फुङलिङ नगरपालिका", "सिदिङबा गाउँपालिका", "मिक्वाखोला गाउँपालिका"],
      "तेह्रथुम": ["म्याङलुङ नगरपालिका", "लालीगुराँस नगरपालिका", "छथर गाउँपालिका"],
      "उदयपुर": ["त्रियुगा नगरपालिका", "कटारी नगरपालिका", "चौदण्डीगढी नगरपालिका", "बेलका नगरपालिका"]
    }
  },
  "मधेश प्रदेश": {
    districts: {
      "बारा": ["कलैया उपमहानगरपालिका", "जीतपुर सिमरा उपमहानगरपालिका", "कोल्हबी नगरपालिका", "निजगढ नगरपालिका"],
      "धनुषा": ["जनकपुरधाम उपमहानगरपालिका", "क्षीरेश्वरनाथ नगरपालिका", "गणेशमान चारनाथ नगरपालिका", "मिथिला नगरपालिका"],
      "महोत्तरी": ["जलेश्वर नगरपालिका", "बर्दिवास नगरपालिका", "गौशाला नगरपालिका", "लोहरपट्टी नगरपालिका"],
      "पर्सा": ["वीरगञ्ज महानगरपालिका", "पोखरिया नगरपालिका", "पर्सागढी नगरपालिका", "बहुदरमाई नगरपालिका"],
      "रौतहट": ["गौर नगरपालिका", "चन्द्रपुर नगरपालिका", "गुजरा नगरपालिका", "देवाही गोनाही नगरपालिका"],
      "सप्तरी": ["राजविराज नगरपालिका", "बोदेबरसाइन नगरपालिका", "डाक्नेश्वरी नगरपालिका", "हनुमाननगर कङ्कालिनी नगरपालिका"],
      "सर्लाही": ["ईश्वरपुर नगरपालिका", "मलंगवा नगरपालिका", "लालबन्दी नगरपालिका", "हरिपुर नगरपालिका"],
      "सिराहा": ["लहान नगरपालिका", "धनगढीमाई नगरपालिका", "सिराहा नगरपालिका", "गोलबजार नगरपालिका"]
    }
  },
  "बागमती प्रदेश": {
    districts: {
      "भक्तपुर": ["भक्तपुर नगरपालिका", "चाँगुनारायण नगरपालिका", "मध्यपुर थिमी नगरपालिका", "सूर्यविनायक नगरपालिका"],
      "चितवन": ["भरतपुर महानगरपालिका", "रत्ननगर नगरपालिका", "राप्ती नगरपालिका", "कालिका नगरपालिका"],
      "धादिङ": ["धुनीबेशी नगरपालिका", "नीलकण्ठ नगरपालिका", "खनियाखोला गाउँपालिका", "गजुरी गाउँपालिका"],
      "दोलखा": ["भीमेश्वर नगरपालिका", "जिरी नगरपालिका", "कालिञ्चोक गाउँपालिका", "गौरीशङ्कर गाउँपालिका"],
      "काठमाडौं": ["काठमाडौं महानगरपालिका", "कागेश्वरी मनहरा नगरपालिका", "कीर्तिपुर नगरपालिका", "शङ्खरापुर नगरपालिका", "बुढानिलकण्ठ नगरपालिका"],
      "काभ्रेपलाञ्चोक": ["धुलिखेल नगरपालिका", "बनेपा नगरपालिका", "पनौती नगरपालिका", "नमोबुद्ध नगरपालिका", "मण्डनदेउपुर नगरपालिका"],
      "ललितपुर": ["ललितपुर महानगरपालिका", "गोदावरी नगरपालिका", "महालक्ष्मी नगरपालिका", "बागमती गाउँपालिका"],
      "मकवानपुर": ["हेटौंडा उपमहानगरपालिका", "थाहा नगरपालिका", "इन्द्रसरोवर गाउँपालिका", "भीमफेदी गाउँपालिका"],
      "नुवाकोट": ["विदुर नगरपालिका", "बेलकोटगढी नगरपालिका", "ककनी गाउँपालिका", "तादी गाउँपालिका"],
      "रामेछाप": ["मन्थली नगरपालिका", "रामेछाप नगरपालिका", "उमाकुण्ड गाउँपालिका", "लिखु गाउँपालिका"],
      "रसुवा": ["उत्तरगया गाउँपालिका", "कालिका गाउँपालिका", "गोसाइकुण्ड गाउँपालिका"],
      "सिन्धुली": ["कमलामाई नगरपालिका", "दुधौली नगरपालिका", "सुनकोशी गाउँपालिका", "गोलन्जोर गाउँपालिका"],
      "सिन्धुपाल्चोक": ["चौतारा साँगाचोकगढी नगरपालिका", "मेलम्ची नगरपालिका", "बाह्रबिसे नगरपालिका", "जुगल गाउँपालिका"]
    }
  },
  "गण्डकी प्रदेश": {
    districts: {
      "बागलुङ": ["बागलुङ नगरपालिका", "गल्कोट नगरपालिका", "जैमुनी नगरपालिका", "ढोरपाटन नगरपालिका"],
      "गोरखा": ["गोरखा नगरपालिका", "पालुङटार नगरपालिका", "सुलिकोट गाउँपालिका", "गण्डकी गाउँपालिका"],
      "कास्की": ["पोखरा महानगरपालिका", "अन्नपूर्ण गाउँपालिका", "माछापुच्छ्रे गाउँपालिका", "मादी गाउँपालिका"],
      "लमजुङ": ["बेसीशहर नगरपालिका", "रैनास नगरपालिका", "सुन्दरबजार नगरपालिका", "क्व्होलासोथार गाउँपालिका"],
      "मनाङ": ["चामे गाउँपालिका", "नासोँ गाउँपालिका", "नर्पा भूमि गाउँपालिका", "मनाङ ङिस्याङ गाउँपालिका"],
      "मुस्ताङ": ["घर्पझोङ गाउँपालिका", "थासाङ गाउँपालिका", "बारागुङ मुक्तिक्षेत्र गाउँपालिका", "लोमन्थाङ गाउँपालिका"],
      "म्याग्दी": ["बेनी नगरपालिका", "अन्नपूर्ण गाउँपालिका", "धौलागिरी गाउँपालिका", "मङ्गला गाउँपालिका"],
      "नवलपुर": ["कावासोती नगरपालिका", "गैंडाकोट नगरपालिका", "देवचुली नगरपालिका", "मध्यविन्दु नगरपालिका"],
      "पर्वत": ["कुश्मा नगरपालिका", "फलेबास नगरपालिका", "जलजला गाउँपालिका", "पैयूँ गाउँपालिका"],
      "स्याङ्जा": ["गल्याङ नगरपालिका", "चापाकोट नगरपालिका", "पुतलीबजार नगरपालिका", "वालिङ नगरपालिका"],
      "तनहुँ": ["भानु नगरपालिका", "भिमाद नगरपालिका", "व्यास नगरपालिका", "शुक्लागण्डकी नगरपालिका"]
    }
  },
  "लुम्बिनी प्रदेश": {
    districts: {
      "अर्घाखाँची": ["सन्धिखर्क नगरपालिका", "सीतगंगा नगरपालिका", "भूमिकास्थान नगरपालिका", "पाणिनी गाउँपालिका"],
      "बाँके": ["नेपालगञ्ज उपमहानगरपालिका", "कोहलपुर नगरपालिका", "राप्ती सोनारी गाउँपालिका", "नरैनापुर गाउँपालिका"],
      "बर्दिया": ["गुलरिया नगरपालिका", "मधुवन नगरपालिका", "राजापुर नगरपालिका", "ठाकुरबाबा नगरपालिका"],
      "दाङ": ["तुलसीपुर उपमहानगरपालिका", "घोराही उपमहानगरपालिका", "लमही नगरपालिका", "गढवा गाउँपालिका"],
      "गुल्मी": ["मुसिकोट नगरपालिका", "रेसुङ्गा नगरपालिका", "इस्मा गाउँपालिका", "मदाने गाउँपालिका"],
      "कपिलवस्तु": ["कपिलवस्तु नगरपालिका", "बाणगंगा नगरपालिका", "बुद्धभूमि नगरपालिका", "शिवराज नगरपालिका"],
      "नवलपरासी (पश्चिम)": ["रामग्राम नगरपालिका", "पाल्ही नन्दन नगरपालिका", "सुनवल नगरपालिका", "प्रतापपुर गाउँपालिका"],
      "पाल्पा": ["तानसेन नगरपालिका", "रामपुर नगरपालिका", "रैनादेवी छहरा गाउँपालिका", "रिब्दीकोट गाउँपालिका"],
      "प्यूठान": ["प्यूठान नगरपालिका", "स्वर्गद्वारी नगरपालिका", "गौमुखी गाउँपालिका", "झिमरुक गाउँपालिका"],
      "रोल्पा": ["रोल्पा नगरपालिका", "रुन्टीगढी गाउँपालिका", "त्रिवेणी गाउँपालिका", "सुनछहरी गाउँपालिका"],
      "रुकुम (पूर्व)": ["भूमे गाउँपालिका", "पुथा उत्तरगंगा गाउँपालिका"],
      "रुपन्देही": ["बुटवल उपमहानगरपालिका", "सिद्धार्थनगर नगरपालिका", "तिलोत्तमा नगरपालिका", "देवदह नगरपालिका", "लुम्बिनी सांस्कृतिक नगरपालिका"]
    }
  },
  "कर्णाली प्रदेश": {
    districts: {
      "दैलेख": ["नारायण नगरपालिका", "दुल्लु नगरपालिका", "चामुण्डा बिन्द्रासैनी नगरपालिका", "आठबीस नगरपालिका"],
      "डोल्पा": ["ठूलीभेरी नगरपालिका", "त्रिपुरासुन्दरी नगरपालिका", "डोल्पो बुद्ध गाउँपालिका", "शे फोक्सुन्डो गाउँपालिका"],
      "हुम्ला": ["सिमकोट गाउँपालिका", "नाम्खा गाउँपालिका", "खार्पुनाथ गाउँपालिका", "सर्केगाड गाउँपालिका"],
      "जाजरकोट": ["भेरी नगरपालिका", "छेडागाड नगरपालिका", "नलगाड नगरपालिका", "बारेकोट गाउँपालिका"],
      "जुम्ला": ["चन्दननाथ नगरपालिका", "कन्कासुन्दरी गाउँपालिका", "सिंजा गाउँपालिका", "हिमा गाउँपालिका"],
      "कालिकोट": ["खाँडाचक्र नगरपालिका", "रास्कोट नगरपालिका", "तिलागुफा नगरपालिका", "पचालझरना गाउँपालिका"],
      "मुगु": ["छायाँनाथ रारा नगरपालिका", "मुगुम कार्मारोंग गाउँपालिका", "सोरु गाउँपालिका", "खत्याड गाउँपालिका"],
      "रुकुम (पश्चिम)": ["मुसिकोट नगरपालिका", "चौरजहारी नगरपालिका", "आठबीसकोट नगरपालिका", "बाँफिकोट गाउँपालिका", "सानी भेरी गाउँपालिका", "त्रिवेणी गाउँपालिका"],
      "सल्यान": ["शारदा नगरपालिका", "बागचौर नगरपालिका", "बनगाड कुपिन्डे नगरपालिका", "कालिमाटी गाउँपालिका"],
      "सुर्खेत": ["वीरेन्द्रनगर नगरपालिका", "भेरीगंगा नगरपालिका", "गुर्भाकोट नगरपालिका", "पञ्चपुरी नगरपालिका"]
    }
  },
  "सुदूरपश्चिम प्रदेश": {
    districts: {
      "अछाम": ["मंगलसेन नगरपालिका", "साँफेबगर नगरपालिका", "कमलबजार नगरपालिका", "पञ्चदेवल विनायक नगरपालिका"],
      "बैतडी": ["दशरथचन्द नगरपालिका", "पाटन नगरपालिका", "मेलौली नगरपालिका", "पुर्चौडी नगरपालिका"],
      "बझाङ": ["जयपृथ्वी नगरपालिका", "बुंगल नगरपालिका", "तलकोट गाउँपालिका", "मस्ता गाउँपालिका"],
      "बाजुरा": ["बडिमालिका नगरपालिका", "त्रिवेणी नगरपालिका", "बुढीगंगा नगरपालिका", "बुढीनन्दा नगरपालिका"],
      "डडेलधुरा": ["अमरगढी नगरपालिका", "परशुराम नगरपालिका", "आलिटाल गाउँपालिका", "भागेश्वर गाउँपालिका"],
      "दार्चुला": ["शैल्यशिखर नगरपालिका", "महाकाली नगरपालिका", "मालिकार्जुन गाउँपालिका", "अपिहिमाल गाउँपालिका"],
      "डोटी": ["दिपायल सिलगढी नगरपालिका", "शिखर नगरपालिका", "पूर्वीचौकी गाउँपालिका", "जोरायल गाउँपालिका"],
      "कैलाली": ["धनगढी उपमहानगरपालिका", "टीकापुर नगरपालिका", "घोडाघोडी नगरपालिका", "लम्कीचुहा नगरपालिका", "भजनी नगरपालिका"],
      "कञ्चनपुर": ["भीमदत्त नगरपालिका", "पुनर्वास नगरपालिका", "बेदकोट नगरपालिका", "महाकाली नगरपालिका", "शुक्लाफाँटा नगरपालिका"]
    }
  }
};

// Get list of all provinces
export const getProvinces = () => {
  return Object.keys(NEPAL_LOCATIONS);
};

// Get districts for a specific province
export const getDistricts = (province) => {
  if (!province || !NEPAL_LOCATIONS[province]) {
    return [];
  }
  return Object.keys(NEPAL_LOCATIONS[province].districts);
};

// Get all districts from all provinces (flat list, sorted alphabetically)
export const getAllDistricts = () => {
  const allDistricts = [];
  const provinces = Object.keys(NEPAL_LOCATIONS);

  provinces.forEach(province => {
    const districts = Object.keys(NEPAL_LOCATIONS[province].districts);
    allDistricts.push(...districts);
  });

  // Sort alphabetically and return
  return allDistricts.sort();
};

// Get municipalities for a specific district
export const getMunicipalities = (province, district) => {
  if (!province || !district || !NEPAL_LOCATIONS[province] || !NEPAL_LOCATIONS[province].districts[district]) {
    return [];
  }
  return NEPAL_LOCATIONS[province].districts[district];
};
